import { CalendarIcon, DownloadIcon, SyncIcon } from "@primer/octicons-react";
import { Box, Label } from "@primer/react";
import { CheckBox } from "devextreme-react";

import DataGrid, {
    Column,
    FilterRow,
    Pager,
    Paging,
    Sorting
} from "devextreme-react/data-grid";
import React, {
    useEffect,
    useMemo,
    useReducer,
    useRef,
    useState
} from "react";
import { useSelector } from "react-redux";
import { Transition } from "semantic-ui-react";
import { hocSinhApi } from "../../../../api/hocSinhApi";
import { saleSetDichVuApi, SF_SALESET_REGISTER_DICHVU_INSERT } from "../../../../api/saleSetRegisterDichVu";
import Button from "../../../../components/ui/button";
import { useCommonContext } from "../../../../contexts/common";
import { showNotify } from "../../../../helpers/toast";
import { ts_hocsinh_viewmodel } from "../../../../models/response/hocsinh/ts_hocsinh";
import { sf_saleset_register_dichvu, sf_saleset_register_dichvu_viewmodel } from "../../../../models/response/sale-set-dichvu/sf_saleset_register_dichvu";
import { RootState } from "../../../../state/reducers";
import DangKyDichVuHocSinhModal from "./DangKyDichVuHocSinhModal";
const hinh_thuc_nop_phis = [
    { id: 13, name: "Theo tháng" },
    { id: 5, name: "Theo kỳ" },
    { id: 10, name: "Theo năm" }
];
const iniState = {
    dangky_dichvus: [],
    selected_dichvu: {},
    selected_dichvu_ids: []
};
const actionTypes = {
    SET_DANGKY_DICHVUS: "SET_DANGKY_DICHVUS",
    SET_SELECTED_DANGKY_DICHVU: "SET_SELECTED_DANGKY_DICHVU",
    SET_SELECTED_DANGKY_DICHVU_IDS: "SET_SELECTED_DANGKY_DICHVU_IDS",

};
const reducer = (state: any, action: any) => {
    switch (action.type) {
        case actionTypes.SET_DANGKY_DICHVUS:
            return {
                ...state,
                dangky_dichvus: action.payload,
            };
        case actionTypes.SET_SELECTED_DANGKY_DICHVU:
            return {
                ...state,
                selected_dichvu: action.payload,
            };
        case actionTypes.SET_SELECTED_DANGKY_DICHVU_IDS:
            return {
                ...state,
                selected_dichvu_ids: action.payload,
            };
        default:
            return state;
    }
};
type DangKyDichVuHocSinhProps = {
    ts_hocsinh_id: number,
}
const DangKyDichVuHocSinh = (props: DangKyDichVuHocSinhProps) => {
    const { createUUID } = useCommonContext();
    const [isShowDetailModal, setIsShowDetailModal] = useState(false);
    const [dataSourceFilter, setDataSourceFilter] = useState<any>([]);
    const { translate, checkAccesiableToV2 } = useCommonContext();
    const { nam_hoc: param_nam_hoc } = useSelector((x: RootState) => x.common);
    const [ts_hocsinh_viewmodel, set_ts_hocsinh_viewmodel] = useState<ts_hocsinh_viewmodel>()
    const [dataEditing, setdataEditing] = useState<sf_saleset_register_dichvu_viewmodel>();

    const grid = useRef<any>();
    const [state, dispatch] = useReducer(reducer, iniState);


    const isAccessibleUpdate = useMemo(() => {
        if (!checkAccesiableToV2(SF_SALESET_REGISTER_DICHVU_INSERT, 'POST')) return false;
        return true;
    }, [checkAccesiableToV2]);

    const handleReloadHocSinh = async () => {
        const res = await hocSinhApi.selectByIdNamHoc({ ts_hocsinh_id: props.ts_hocsinh_id, nam_hoc: param_nam_hoc })
        if (res.is_success) {
            set_ts_hocsinh_viewmodel(res.data)
        }
    }
    const handleReloadDichVus = async () => {
        const res = await saleSetDichVuApi.select_by_hocsinh({
            ts_hocsinh_id: props.ts_hocsinh_id,
            nam_hoc: param_nam_hoc,
        });
        if (res.is_success) {
            dispatch({ type: actionTypes.SET_DANGKY_DICHVUS, payload: res.data });
            setDataSourceFilter(res.data.filter((x: any) => x.ts_hocsinh_id == props.ts_hocsinh_id && x.sf_saleset_register_dichvu_status_id == 1))
        }
    };
    useEffect(() => {
        handleReloadDichVus();
        handleReloadHocSinh();
    }, []);
    useEffect(() => {
        if (state.dangky_dichvus) {
            let temp = [...state.dangky_dichvus]
            setDataSourceFilter(temp)
        }
    }, []);

    const handleSubmitDetailModal = async (data: sf_saleset_register_dichvu_viewmodel) => {
        const datasend: sf_saleset_register_dichvu = {
            id: data.id,
            ts_hocsinh_id: data.ts_hocsinh_id,
            nam_hoc: data.nam_hoc,
            sf_khoannop_group_id: data.sf_khoannop_group_id,
            sf_saleset_register_dichvu_status_id: data.sf_saleset_register_dichvu_status_id,
            is_active: data.is_active,
            tu_ngay: data.tu_ngay,
            den_ngay: data.den_ngay,
            sf_saleset_register_type_id: data.sf_saleset_register_type_id
        }
        const res = await saleSetDichVuApi.Update(datasend);
        if (res.is_success) {
            setIsShowDetailModal(false)
            handleReloadDichVus();
            dispatch({ type: actionTypes.SET_SELECTED_DANGKY_DICHVU, payload: [] });
            showNotify({
                message: `Cập nhật thành công`,
                type: "success"
            })
        }
        else {
            showNotify({
                message: `Có lỗi`,
                type: "warning"
            })
        }
    }
    const handleCheckBoxChange = async (e: any, cellData: any, item: any) => {
        if (e.event) {
            const datasend = {
                id: cellData.data.id,
                sf_saleset_register_type_id: item.id
            }
            if (cellData.data.sf_saleset_register_type_id === item.id) return;
            const res = await saleSetDichVuApi.UpdateHinhThucNopPhi(datasend);
            if (res.is_success) {
                const updatedData = { ...cellData.data, sf_saleset_register_type_id: item.id };
                setDataSourceFilter((prevData: any) => {
                    return prevData.map((data: any) =>
                        data.id === cellData.data.id ? updatedData : data
                    );
                });
            }

        }
    };
    const btnEdit_click = (data: any) => {
        setdataEditing(data);
        setIsShowDetailModal(true);
    };

    const cellRender = (data: any) => {
        return (
            <div>
                <span
                    style={{ cursor: "pointer", color: "green" }}
                    onClick={() => {
                        btnEdit_click(data.data);
                    }}
                >
                    <i aria-hidden="true" className="icon edit"></i>{" "}
                </span>
            </div>
        );
    };
    return (
        <React.Fragment>
            <Box sx={{ p: 2 }}>
                <Transition
                    animation="scale"
                    visible={true}
                    duration={200}
                    transitionOnMount={true}
                >
                    <div>
                        <div className="row">
                            <Box sx={{
                                display: "flex",
                                width: "100%",
                                marginBottom: "10px",
                                pt: 1
                            }}>
                                {/* <b style={{ flex: 1, fontSize: "1.2rem", marginLeft: 15 }}>Thông tin dịch vụ học sinh {ts_hocsinh_viewmodel?.ho_ten} ({ts_hocsinh_viewmodel?.ma_hs})</b> */}

                                {/* <Box sx={{ mr: 2 }}>
                                    <Button
                                        type="normal"
                                        icon="fas fa-plus"
                                        text="Thêm mới"
                                        id="btnRegister"
                                        onClick={() => {
                                            setIsShowDetailModal(true);
                                        }}
                                    />{" "}

                                </Box> */}
                                <Box sx={{ ml: 'auto', mr: 4, display: 'flex', alignItems: 'center' }}>
                                    <Button sx={{ ml: 2 }} variant="default" leadingVisual={SyncIcon} onClick={() => {
                                        handleReloadDichVus();
                                    }}>Làm mới</Button>
                                    {/* <Button sx={{ ml: 2 }} variant="primary" leadingVisual={PlusIcon} onClick={handleBtnInsertClick}>Thêm mới</Button> */}
                                    <Button sx={{ ml: 2 }} leadingVisual={DownloadIcon} variant="default" onClick={() => {
                                        grid.current.instance.exportToExcel();
                                    }}>Xuất excel</Button>

                                </Box>
                            </Box>
                            <div className="col-md-12">
                                {dataSourceFilter.length === 0 ? (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            minHeight: "60vh", // Giữ nội dung căn giữa nhưng có thể mở rộng nếu cần
                                            textAlign: "center"
                                        }}
                                    >
                                        <img
                                            src="https://true-north-school.s3.cloudfly.vn/fee/datagrid_empty"
                                            alt="Không có dữ liệu"
                                            style={{ width: "60px", height: "60px", marginBottom: "5px" }}
                                        />
                                        <Box sx={{ fontSize: "13px", fontWeight: "400", color: "#8C8C8C" }}>
                                            Chưa có dữ liệu đăng ký dịch vụ
                                        </Box>
                                    </Box>


                                ) : (
                                    <DataGrid
                                        ref={grid}
                                        keyExpr="id"
                                        dataSource={dataSourceFilter}
                                        columnHidingEnabled={false}
                                        columnAutoWidth={true}
                                        showBorders={true}
                                        showColumnLines={true}
                                        showRowLines={true}
                                        rowAlternationEnabled={true}
                                        allowColumnResizing={true}
                                        columnResizingMode={"nextColumn"}
                                        hoverStateEnabled={false}
                                        focusedRowEnabled={true}
                                        height={window.innerHeight - 340}
                                        className={"table-noborder-left table-white-space"}
                                        noDataText="Không có dữ liệu"
                                        wordWrapEnabled={false}
                                        paging={{ enabled: true }}
                                    >
                                        <Paging defaultPageSize={50} />
                                        <Sorting mode="multiple" />
                                        {/* <Selection mode="single"></Selection> */}
                                        <FilterRow visible={true} />
                                        {isAccessibleUpdate &&
                                            <Column
                                                key={createUUID()}
                                                alignment="center"
                                                width={50}
                                                fixed
                                                cellRender={(cellData: any) => {
                                                    if (cellData.data.sf_saleset_register_dichvu_status_id !== 3) {
                                                        return (
                                                            <div>
                                                                {cellRender(cellData)}
                                                            </div>
                                                        );
                                                    }
                                                    return null;
                                                }}
                                            />
                                        }
                                        <Column key={createUUID()}
                                            minWidth={100}
                                            dataField="trang_thai"
                                            caption={translate("Trạng thái HS")}
                                        ></Column>
                                        <Column key={createUUID()}
                                            minWidth={100}
                                            dataField="ma_hs"
                                            caption={translate("Mã HS")}
                                        ></Column>
                                        <Column key={createUUID()}
                                            dataField="ho_ten"
                                            minWidth={150}
                                            caption={translate("Họ tên")}
                                        ></Column>,
                                        <Column key={createUUID()} width={120} caption={"Ngày sinh"} dataField={'ngay_sinh'} dataType={"date"} format={"dd/MM/yyyy"}></Column>

                                        <Column key={createUUID()} minWidth={200} caption={"Dịch vụ"} dataField={'ten_khoan_nop_group'} dataType={"string"}
                                        // cellRender={(data: any) => {
                                        //     if (data.data.ten_khoan_nop_group) {
                                        //         return (
                                        //             <Label variant="accent"  >
                                        //                 {data.data.ten_khoan_nop_group}
                                        //             </Label>
                                        //         );
                                        //     }
                                        //     return <></>
                                        // }}
                                        ></Column>


                                        <Column key={createUUID()} minWidth={100} caption={"Hình thức nộp"}>
                                            {hinh_thuc_nop_phis.map((item) => (
                                                <Column
                                                    key={item.id}
                                                    minWidth={100}
                                                    caption={item.name}
                                                    cellRender={(cellData: any) => {
                                                        console.log(cellData.data)
                                                        const isChecked = cellData.data.sf_saleset_register_type_id === item.id;

                                                        return (
                                                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                <CheckBox
                                                                    value={isChecked}
                                                                    disabled={cellData.data.sf_saleset_register_dichvu_status_id == 3}
                                                                    onValueChanged={(e) => handleCheckBoxChange(e, cellData, item)}  // Truyền vào cellData và item
                                                                />
                                                            </Box>

                                                        );
                                                    }}
                                                />
                                            ))}
                                        </Column>

                                        <Column
                                            width={300}
                                            key={createUUID()}
                                            caption="Thời gian đăng ký"
                                            dataField="tu_ngay"
                                            cellRender={({ data }) => {
                                                const formatDate = (date: string | Date | null) => {
                                                    if (!date) return "";
                                                    return new Intl.DateTimeFormat("vi-VN", {
                                                        day: "2-digit",
                                                        month: "2-digit",
                                                        year: "numeric",
                                                    }).format(new Date(date));
                                                };

                                                return (
                                                    <div style={{ display: "flex", alignItems: "center", gap: "5px", fontWeight: 500 }}>
                                                        <span style={{ color: "green" }}><CalendarIcon size={16} /> </span> <span>{formatDate(data.tu_ngay)}</span>
                                                        <span>-</span>
                                                        <span style={{ color: "red" }}><CalendarIcon size={16} /> </span> <span>{formatDate(data.den_ngay)}</span>
                                                    </div>
                                                );
                                            }}
                                        ></Column>
                                        <Column key={createUUID()} minWidth={100} caption={"Trạng thái đăng ký"} dataField={'trang_thai_dich_vu'} dataType={"string"}
                                            cellRender={(cellData: any) => {
                                                if (cellData.data.trang_thai_dich_vu) {
                                                    const variant =
                                                        cellData.data.sf_saleset_register_dichvu_status_id === 1 ? 'success' :
                                                            cellData.data.sf_saleset_register_dichvu_status_id === 2 ? 'done' :
                                                                cellData.data.sf_saleset_register_dichvu_status_id === 3 ? 'danger' :
                                                                    'default';

                                                    return (
                                                        <Label variant={variant}>
                                                            {cellData.data.trang_thai_dich_vu}
                                                        </Label>
                                                    );
                                                }
                                                return <></>
                                            }}
                                        ></Column>
                                        <Column key={createUUID()} width={250} caption={"Cập nhật mới nhất"}>
                                            <Column key={createUUID()} caption={"Ngày cập nhật"} dataField={'ngay_huy'} dataType={"date"} format={"dd/MM/yyyy"}></Column>
                                            <Column key={createUUID()} caption={"Người cập nhật"} dataField={'nguoi_huy'} dataType={"string"}></Column>
                                        </Column>
                                        <Pager
                                            showPageSizeSelector={true}
                                            allowedPageSizes={[50, 200, 500]}
                                            infoText={`${translate("Trang")} {0} /{1} ({2} ${translate(
                                                "dòng"
                                            )})`}
                                            showInfo={true}
                                        />
                                    </DataGrid>
                                )}
                            </div>

                            {isShowDetailModal &&
                                <DangKyDichVuHocSinhModal
                                    animationOf="#btnInsert"
                                    sf_saleset_register_dichvu_editting={dataEditing}
                                    title={`${dataEditing ? `Cập nhật` : "Đăng ký hình thức nộp phí"}`}
                                    onClose={() => {
                                        setdataEditing(undefined);
                                        setIsShowDetailModal(false);
                                        handleReloadDichVus();
                                    }}
                                    onSubmit={handleSubmitDetailModal}
                                    ts_hocsinh={ts_hocsinh_viewmodel}

                                />
                            }
                        </div>
                    </div>
                </Transition>
            </Box>
        </React.Fragment>
    );
};
export default DangKyDichVuHocSinh;
